module.exports = __webpack_public_path__ + "img/2bg@2x.a25f3e6f.png";